
import HomeMain from '../Home/HomeMain'
import WebDevelop from '../Services/WebDevelop'
import MobileDevelop from '../Services/MobileDevelop'
import SoftwareDevelop from '../Services/SoftwareDevelop'
import Devops from '../Services/Devops'
import Cloud from '../Services/Cloud'
import Digital from '../Services/Digital'
import Aboutus from '../Aboutus'
import Contact from '../Contact'
import Project from '../Project'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PrivacyPolicy from '../PrivacyandPolicy'
import BlogsMain from '../blogs/BlogsMain'
import BlogPage from '../blogs/BlogPage'
import Press from './Press'
// import Menu from 'react-select/dist/declarations/src/components/Menu'
import PressLogo from './PressLogo'
import CaseStudies from '../blogs/caseStudies'
import CloudAdaption from '../solutions/CloudAdaption'
import ProcessIntegration from '../solutions/ProcessIntegration'
import Manufacturing from '../solutions/Manufacturing'
import Industrial from '../solutions/Industrial'
import SOE from '../solutions/SOE'
import CustomerExp from '../solutions/CustomerExp'

const Routing = () => {
    return (
        <>
            <BrowserRouter>

                <Routes>
                    <Route path='/' element={<HomeMain />}></Route>
                    <Route path='/blogs' element={<BlogsMain />}></Route>
                    <Route path='/blogs/:slug' element={<BlogPage />}></Route>
                    <Route path='/case-studies' element={<CaseStudies />}></Route>
                    <Route path='/web-development' element={<WebDevelop />}></Route>
                    <Route path='/mobile-app-development' element={<MobileDevelop />}></Route>
                    <Route path='/software-development' element={<SoftwareDevelop />}></Route>
                    <Route path='/dev-ops' element={<Devops />}></Route>
                    <Route path='/cloud-computing' element={<Cloud />}></Route>
                    <Route path='/digital-marketing' element={<Digital />}></Route>
                    <Route path='/projects' element={<Project />}></Route>
                    <Route path='/about-us' element={<Aboutus />}></Route>

                    <Route path="/press-release" element={<Press />} />

                    <Route path='/cloud-adoption' element={<CloudAdaption />}></Route>
                    <Route path='/process-integration' element={<ProcessIntegration />}></Route>
                    <Route path='/manufacturing-execution' element={<Manufacturing />}></Route>
                    <Route path='/industrial-iot' element={<Industrial />}></Route>
                    <Route path='/systems-of-engagement' element={<SOE />}></Route>
                    <Route path='/customer-experience' element={<CustomerExp />}></Route>

                    <Route path="/presslogo/:id" element={<PressLogo />} />

                    <Route path='/contact-us' element={<Contact />}></Route>
                    <Route path='/privacy-policy' element={<PrivacyPolicy />}></Route>
                </Routes>
            </BrowserRouter>

        </>
    )
}

export default Routing;
